import { render, staticRenderFns } from "./PacketCheckDetail.vue?vue&type=template&id=89bbab22&scoped=true"
import script from "./PacketCheckDetail.vue?vue&type=script&lang=js"
export * from "./PacketCheckDetail.vue?vue&type=script&lang=js"
import style0 from "./PacketCheckDetail.vue?vue&type=style&index=0&id=89bbab22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bbab22",
  null
  
)

export default component.exports